import ko from "knockout";
import navHelper from "services/navHelper";

function handleClick(valueAccessor: () => any, event: Event) {
    if (event) {
        event.preventDefault();
    }
    const path = valueAccessor();
    if (path) {
        navHelper.navigateTo(path, undefined, false);
    }
}

ko.bindingHandlers.navigateTo = {
    init(element: HTMLElement, valueAccessor) {
        const path = valueAccessor();
        if (element instanceof HTMLAnchorElement && path) {
            // Satisfies Accessibility Requirements and allows to open links in new tabs with host.
            element.setAttribute("href", navHelper.asHostUrl(path));
        }
        const handleClickThis = handleClick.bind(null, valueAccessor);
        element.addEventListener("click", handleClickThis);
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            element.removeEventListener("click", handleClickThis);
        });
    },
};
